export default __webpack_public_path__ + "static/media/logo.39f4c99e.png";